import React from "react";
import { Route } from "react-router-dom";
import Meta from "../shared/atoms/Meta";

const SellerLayout = ({ children }) => (
  <div>
    <Meta title="SaRa Marketplace - Seller" />
    {children}
  </div>
);

const SellerLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <React.Fragment>
      <Route
        {...rest}
        render={(matchProps) => (
          <SellerLayout>
            <Component {...matchProps} />
          </SellerLayout>
        )}
      />
    </React.Fragment>
  );
};

export default SellerLayoutRoute;
